module.exports = __webpack_public_path__ + "img/research-soho-retail-single.7cf62791.png";